<template>
  <div class="field">
    <InputNumber @blur="v.$touch" :useGrouping="useGrouping" :max="max" :min="min" v-model="theModel" class="w-100"
      :inputClass="'custom-input form-control'" :class="{ 'p-invalid': v.$error }" :readonly="readonly" :mode="mode"
      :maxFractionDigits="maxFractionDigits" :minFractionDigits="minFractionDigits" :inputProps="inputProps"/>
    <small v-if="v.$error || v.$pending.$response" class="p-error">{{ $t('registration.requiredValidationError')
    }}</small>
  </div>
</template>

<script>
import InputNumber from "primevue/inputnumber";
import { computed } from "vue";
import useVuelidate from "@vuelidate/core";

export default {
  components: { InputNumber },
  props: {
    modelValue: String,
    scope: String,
    rules: Object,
    max: {
      type: Number,
    },
    min: {
      type: Number,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: 'decimal',
    },
    maxFractionDigits: {
      type: Number || null,
      default: null,
    },
    minFractionDigits: {
      type: Number || null,
      default: null,
    },
    useGrouping: {
      type: Boolean,
      default: false,
    },
    inputProps: {
      type: Object
    }
  },
  emits: ["update:modelValue"],
  async setup(props, { emit }) {
    const theModel = computed({
      get: () => props.modelValue,
      set: (value) => emit("update:modelValue", value),
    });

    const v = useVuelidate(props.rules, theModel, { $scope: props.scope });

    return { theModel, v };
  },
};
</script>
